import { render, staticRenderFns } from "./SpecimenReportByPostureStatus.vue?vue&type=template&id=3185cc67"
import script from "./SpecimenReportByPostureStatus.vue?vue&type=script&lang=js"
export * from "./SpecimenReportByPostureStatus.vue?vue&type=script&lang=js"
import style0 from "./SpecimenReportByPostureStatus.vue?vue&type=style&index=0&id=3185cc67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports